import styled from "styled-components";
import { COLORS, LEVELS } from "styles/colors";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { ReactComponent as AccountSVG } from "assets/icons/sidenav/account.svg";
import { handleCopyClipBoard } from "utils/functions";
import { IoIosCopy } from "react-icons/io";

export type LicenseStatus = "PREPARING";

interface Props {
  level: LEVEL_TYPE;
  accountId: string;
  isCopyable?: boolean;
}

const AccountId = ({ level, accountId, isCopyable }: Props) => (
  <Label
    level={level}
    isCopyable={isCopyable}
    className="account-id-label"
    onClick={(e) => {
      if (!isCopyable) return;
      e.stopPropagation();
      handleCopyClipBoard(accountId);
    }}
    data-testid="atoms-text-labels-account-id"
  >
    <AccountSVG />
    <span>{accountId}</span>
    {isCopyable && <IoIosCopy size={11} />}
  </Label>
);

const Label = styled.span<{ level: LEVEL_TYPE; isCopyable?: boolean }>`
  padding: 2px 4px;
  border-radius: 2px;
  background-color: ${({ level }) => LEVELS[level]};
  font-size: ${calcRem(12)};
  color: ${COLORS.WHITE};
  ${FLEX.FlexStartCenter};
  display: inline-flex;
  gap: 3px;
  white-space: nowrap;
  min-width: 75px;
  ${({ isCopyable }) =>
    isCopyable &&
    `
    cursor: pointer;
  `}
  svg {
    width: ${calcRem(11)};
    height: ${calcRem(11)};
  }
`;
export default AccountId;
